interface TrpcFetchOptions {
  request: typeof globalThis.fetch;
}

function httpStatus(response: Response): string {
  const statusText = response.statusText.trim();
  return `HTTP ${response.status}${statusText ? ` ${statusText}` : ''}`;
}

/**
 * Preserve valid tRPC error payloads while translating non-JSON HTTP failures (a proxy's 502, an
 * HTML error page) into a readable error instead of a JSON parser message.
 */
export function createTrpcFetch({ request }: TrpcFetchOptions): typeof globalThis.fetch {
  return async (input, init) => {
    const response = await request(input, init);
    if (response.ok) return response;

    try {
      await response.clone().json();
    } catch (error) {
      throw new Error(`Request failed (${httpStatus(response)}).`, { cause: error });
    }

    return response;
  };
}
